export const mergeCallbacks = (...callbacks) => {
    return (...args) => {
        callbacks.forEach((func) => func?.(...args));
    };
};
